/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBookingInfoRequest
 */
export interface GetBookingInfoRequest {
    /**
     * The Gondola-internal numeric booking id (as a string).
     * @type {string}
     * @memberof GetBookingInfoRequest
     */
    bookingId: string;
}

/**
 * Check if a given object implements the GetBookingInfoRequest interface.
 */
export function instanceOfGetBookingInfoRequest(value: object): value is GetBookingInfoRequest {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function GetBookingInfoRequestFromJSON(json: any): GetBookingInfoRequest {
    return GetBookingInfoRequestFromJSONTyped(json, false);
}

export function GetBookingInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBookingInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
    };
}

export function GetBookingInfoRequestToJSON(json: any): GetBookingInfoRequest {
    return GetBookingInfoRequestToJSONTyped(json, false);
}

export function GetBookingInfoRequestToJSONTyped(value?: GetBookingInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
    };
}

